import {gsap, Linear} from "gsap";
import {SmartComponent} from "smart-component-js";
import $ from "jquery";

class VisualParallaxComponent extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		let $el = $(this.element);
		//var leftElemQuery = $el.data("left-elem-query");
		var textElemQuery = $el.data("text-elem-query");
		//var rightElemQuery = $el.data("right-elem-query");
		var detachElemQuery = $el.data("trigger-end-elem-query");
		this.init($el.find(textElemQuery)[0], $(detachElemQuery));
	}

	init(textElement, $detachElement) {
		gsap.set(textElement, {x: 100, alpha: 0});

		setTimeout(() => {
			gsap.to(textElement, {x: 0, delay: 0.7, alpha: 1, ease: Linear.easeOut});
		}, 800);
		$(window).scroll(() => {
			if ($(window).width() > 767) {
				let currentScrollTop = $(window).scrollTop();
				if ($detachElement.length == 0 || $detachElement.offset().top > currentScrollTop)
					if (currentScrollTop > this.scrollTop) {
						//gsap.to(leftElement,  {x: -25, alpha: 1, ease: Linear.easeOut});
					} else if (currentScrollTop < this.scrollTop) {

						gsap.to(textElement,  {x: 0, alpha: 1, ease: Linear.easeIn});
					}
				this.scrollTop = currentScrollTop;
			}
		});
	}

}


export default VisualParallaxComponent;



